module.exports = __webpack_public_path__ + "media/C_game_win.0a6ef4bd.mp3";